import { OrganizationAuthMethodEnum } from 'src/api/main'

import type { ProviderId, SocialProviderId } from './types'

/**
 * Local constant for the email-OTP method. Will be folded into
 * `OrganizationAuthMethodEnum` once the backend schema is deployed and
 * `npm run openapi` regenerates the client — but until then the extra value
 * lives here so TS stays happy without editing auto-generated files.
 */
export const EMAIL_OTP_METHOD = 'email_otp'
export const QR_LOGIN_METHOD = 'qr_login'

export const providerOrder: ProviderId[] = [
  OrganizationAuthMethodEnum.PASSWORD,
  EMAIL_OTP_METHOD,
  QR_LOGIN_METHOD,
  OrganizationAuthMethodEnum.GOOGLE,
  OrganizationAuthMethodEnum.ENTRAID,
  OrganizationAuthMethodEnum.APPLE,
  OrganizationAuthMethodEnum.PASSKEY
]

export const socialProviderOrder: SocialProviderId[] = [
  OrganizationAuthMethodEnum.GOOGLE,
  OrganizationAuthMethodEnum.ENTRAID,
  OrganizationAuthMethodEnum.APPLE
]

export const isSocialProviderId = (
  providerId: ProviderId
): providerId is SocialProviderId =>
  socialProviderOrder.includes(providerId as SocialProviderId)

// `defaultSystemMethodsOrder` intentionally omits EMAIL_OTP: it feeds the
// profile's "linkable methods" UI, and email-OTP isn't a per-user linkable
// provider — it's an org-level sign-in option listed via `providerOrder`.
// Typed with the generated enum directly so consumers that require the
// narrow type (no `'email_otp'`) can accept it without casting.
export const defaultSystemMethodsOrder: OrganizationAuthMethodEnum[] = [
  OrganizationAuthMethodEnum.PASSWORD,
  OrganizationAuthMethodEnum.GOOGLE,
  OrganizationAuthMethodEnum.APPLE
]

export const defaultSystemSocialProviderOrder: SocialProviderId[] = [
  OrganizationAuthMethodEnum.GOOGLE,
  OrganizationAuthMethodEnum.APPLE
]
